export default {"src":"/_next/static/media/ticket-color.7bbf6824.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};